.radios {
  margin-bottom: 20px;
  align-items: flex-start;
  display: flex;
  flex-direction: column;
}

.specificTimeOptions {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.loader {
  text-align: center;
}
